import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CIVILITY } from 'constants/Global';
import Radio from 'common/Form/components/Radio';
import FormItem from 'common/Form/components/FormItem';

import { CivilityWrapper } from '../UI';

/** @type {React.FC<undefined>} */
const Civility = () => {
  const name = 'customerInfo.civility';

  return (
    <FormItem
      title={<FormattedMessage id="web.civility" defaultMessage="Civility" />}
      data-cy="input-civility"
      required
    >
      <CivilityWrapper>
        <Radio value={CIVILITY.MS} name={name}>
          <FormattedMessage id="civility.ms" defaultMessage="Ms" />
        </Radio>
        <Radio value={CIVILITY.MR} name={name}>
          <FormattedMessage id="civility.mr" defaultMessage="Mr" />
        </Radio>
        <Radio value={CIVILITY.NONE} name={name}>
          <FormattedMessage id="civility.none" defaultMessage="Other" />
        </Radio>
      </CivilityWrapper>
    </FormItem>
  );
};

export default Civility;
